module.exports = __webpack_public_path__ + "static/media/notificationNew.d801e9a8.svg";